/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@ember/component';
import { set, action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { isEmpty } from '@ember/utils';
import config from 'cio/config/environment';
import { task } from 'ember-concurrency';
import { timeout } from 'ember-concurrency';
import Ember from 'ember';
import { tagName } from '@ember-decorators/component';
import { IdentifierKey } from 'cio/utils/identifiers';
import { CREATED_IN_CIO_AT } from 'cio/utils/attributes';

const VALIDATE_DEBOUNCE_DELAY = config.APP.debounceDuration;

@tagName('')
export default class VisualWorkflowBuilderEditActionSidebarResponseToProfileAttributesMapping extends Component {
  'data-test-action-composer-map-response-attributes' = true;

  @service environment!: EnvironmentService;

  actionAbstract: any;
  onDebouncedMappingChange: (index: number) => void = (_index) => {};

  errors: string[][] = [];

  @computed('actionAbstract.attributesMappings.[]')
  get _isResponseProfileAttributesMappingEnabled() {
    return this.actionAbstract && !isEmpty(this.actionAbstract.attributesMappings);
  }

  @computed('environment.sentAttributes')
  get attributeOptions() {
    return this.environment.sentAttributes.filter((attr) => ![IdentifierKey.CioId, CREATED_IN_CIO_AT].includes(attr));
  }

  _validateLiquidTask = task({ restartable: true }, async (_liquidString: string, index: number) => {
    if (!Ember.testing) {
      await timeout(VALIDATE_DEBOUNCE_DELAY);
    }

    await this.onDebouncedMappingChange(index);
  });

  @action
  mapAnotherAttribute() {
    this.actionAbstract.attributesMappings.pushObject({
      name: '',
      value: '{{response.REPLACE_ME}}',
    });
  }

  @action
  mappingChange(index: number, type: 'value' | 'name', value: string | null) {
    if (type === 'value') {
      set(this.actionAbstract.attributesMappings[index], 'value', value);

      // trigger server-side Liquid validation, executed in parent component:
      (this._validateLiquidTask as any).perform(value, index);
    } else if (type === 'name') {
      set(this.actionAbstract.attributesMappings[index], 'name', value);
    }
  }

  @action
  removeMapping(index: number) {
    let newAttributesMappings = [...this.actionAbstract.attributesMappings];

    newAttributesMappings.splice(index, 1);

    this.actionAbstract.set('attributesMappings', newAttributesMappings);
  }
}
